import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-primary-100 text-left text-gray-800" }
const _hoisted_2 = { class: "flex items-center justify-between gap-3 px-4 py-3" }
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  class: "h-4 w-4",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M15 18l-6-6 6-6" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 戻る ")
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "flex min-w-0 items-center gap-3"
}
const _hoisted_7 = {
  key: 0,
  class: "truncate text-xs text-gray-500"
}
const _hoisted_8 = { class: "flex justify-center px-4 pb-12" }
const _hoisted_9 = { class: "w-full max-w-md space-y-4" }
const _hoisted_10 = {
  class: "rounded-2xl bg-white px-6 py-8 shadow-sm",
  "aria-labelledby": "change-password-title"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", {
  class: "mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-gray-700",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("svg", {
    class: "h-6 w-6",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, [
    /*#__PURE__*/_createVNode("rect", {
      x: "5",
      y: "11",
      width: "14",
      height: "10",
      rx: "2"
    }),
    /*#__PURE__*/_createVNode("path", { d: "M8 11V7a4 4 0 0 1 8 0v4" })
  ])
], -1)
const _hoisted_12 = {
  id: "change-password-title",
  class: "text-xl font-bold"
}
const _hoisted_13 = {
  key: 0,
  class: "mt-2 text-sm leading-relaxed text-gray-600"
}
const _hoisted_14 = {
  key: 1,
  role: "status",
  class: "mt-6 flex items-start gap-2 rounded-md bg-green-50 px-4 py-3 text-sm text-green-800"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("svg", {
  class: "mt-0.5 h-4 w-4 flex-none",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M5 13l4 4L19 7" })
], -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("p", null, "パスワードを変更しました。画面を切り替えています…", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("label", {
  for: "tutor-new-password",
  class: "mb-1 block text-sm font-medium text-gray-600"
}, "新しいパスワード", -1)
const _hoisted_18 = { class: "relative" }
const _hoisted_19 = {
  key: 0,
  class: "h-5 w-5",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("path", { d: "M4.5 4.5l15 15M9.7 6c.7-.2 1.5-.3 2.3-.3 4.5 0 8.1 2.7 9.8 6.8-.6 1.5-1.4 2.7-2.5 3.8M16.5 18.4c-1.4.7-2.9.9-4.5.9-4.5 0-8.1-2.7-9.8-6.8.7-1.7 1.7-3.2 3-4.3" }, null, -1)
const _hoisted_21 = {
  key: 1,
  class: "h-5 w-5",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("path", { d: "M2.2 12.5C3.9 8.4 7.5 5.7 12 5.7s8.1 2.7 9.8 6.8c-1.7 4.1-5.3 6.8-9.8 6.8s-8.1-2.7-9.8-6.8z" }, null, -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("circle", {
  cx: "12",
  cy: "12.5",
  r: "3"
}, null, -1)
const _hoisted_24 = {
  id: "tutor-password-rules",
  "aria-label": "パスワードの条件",
  class: "mt-2 space-y-1"
}
const _hoisted_25 = {
  key: 0,
  class: "h-3 w-3",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("path", { d: "M5 13l4 4L19 7" }, null, -1)
const _hoisted_27 = {
  key: 1,
  class: "h-3 w-3",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("path", { d: "M6 6l12 12M18 6L6 18" }, null, -1)
const _hoisted_29 = {
  key: 0,
  class: "sr-only"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("label", {
  for: "tutor-confirm-password",
  class: "mb-1 block text-sm font-medium text-gray-600"
}, "新しいパスワード（確認）", -1)
const _hoisted_31 = { class: "relative" }
const _hoisted_32 = {
  key: 0,
  class: "h-5 w-5",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("path", { d: "M4.5 4.5l15 15M9.7 6c.7-.2 1.5-.3 2.3-.3 4.5 0 8.1 2.7 9.8 6.8-.6 1.5-1.4 2.7-2.5 3.8M16.5 18.4c-1.4.7-2.9.9-4.5.9-4.5 0-8.1-2.7-9.8-6.8.7-1.7 1.7-3.2 3-4.3" }, null, -1)
const _hoisted_34 = {
  key: 1,
  class: "h-5 w-5",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.8",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "aria-hidden": "true"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("path", { d: "M2.2 12.5C3.9 8.4 7.5 5.7 12 5.7s8.1 2.7 9.8 6.8c-1.7 4.1-5.3 6.8-9.8 6.8s-8.1-2.7-9.8-6.8z" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createVNode("circle", {
  cx: "12",
  cy: "12.5",
  r: "3"
}, null, -1)
const _hoisted_37 = {
  key: 1,
  role: "alert",
  class: "rounded-md bg-red-50 px-4 py-3 text-sm text-red-700"
}
const _hoisted_38 = { class: "flex flex-wrap justify-end gap-3" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("キャンセル")
const _hoisted_40 = {
  key: 3,
  class: "mt-6 border-t pt-4 text-xs leading-relaxed text-gray-500"
}
const _hoisted_41 = {
  key: 0,
  class: "rounded-2xl bg-white px-6 py-6 shadow-sm",
  "aria-labelledby": "change-password-help-title"
}
const _hoisted_42 = /*#__PURE__*/_createVNode("h2", {
  id: "change-password-help-title",
  class: "font-bold"
}, " お困りのときは ", -1)
const _hoisted_43 = {
  key: 0,
  class: "mt-3 flex flex-wrap items-center gap-2 text-sm text-gray-600"
}
const _hoisted_44 = /*#__PURE__*/_createVNode("p", { role: "alert" }, "お問い合わせ先とお知らせを読み込めませんでした。", -1)
const _hoisted_45 = {
  key: 1,
  class: "mt-3 text-sm text-gray-500"
}
const _hoisted_46 = {
  key: 0,
  class: "mt-3 space-y-2"
}
const _hoisted_47 = /*#__PURE__*/_createVNode("h3", { class: "mt-5 text-sm font-bold" }, "お知らせ", -1)
const _hoisted_48 = {
  key: 1,
  class: "mt-2 text-sm text-gray-500"
}
const _hoisted_49 = {
  key: 2,
  class: "mt-1 divide-y"
}
const _hoisted_50 = { class: "block text-xs text-gray-500" }
const _hoisted_51 = { class: "block text-sm text-gray-800 underline" }
const _hoisted_52 = /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "（新しいタブで開きます）", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MButton = _resolveComponent("MButton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (!_ctx.required)
        ? (_openBlock(), _createBlock("button", {
            key: 0,
            type: "button",
            class: "flex items-center gap-1 rounded-md px-2 py-1 text-sm text-gray-600 transition-colors duration-200 hover:bg-white focus:outline-none focus:ring-2 focus:ring-primary-500",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
          }, [
            _hoisted_3,
            _hoisted_4
          ]))
        : (_openBlock(), _createBlock("span", _hoisted_5)),
      (_ctx.required)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            (_ctx.email)
              ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.email), 1))
              : _createCommentVNode("", true),
            _createVNode("button", {
              type: "button",
              class: "flex-none rounded-md px-2 py-1 text-sm text-gray-600 transition-colors duration-200 hover:bg-white focus:outline-none focus:ring-2 focus:ring-primary-500",
              disabled: _ctx.busy,
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
            }, " ログアウト ", 8, ["disabled"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("main", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("section", _hoisted_10, [
          _hoisted_11,
          _createVNode("h1", _hoisted_12, _toDisplayString(_ctx.required
                ? "パスワードを変更してください"
                : "新しいパスワードを設定"), 1),
          (_ctx.lead)
            ? (_openBlock(), _createBlock("p", _hoisted_13, _toDisplayString(_ctx.lead), 1))
            : _createCommentVNode("", true),
          (_ctx.done)
            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                _hoisted_15,
                _hoisted_16
              ]))
            : (_openBlock(), _createBlock("form", {
                key: 2,
                class: "mt-6 space-y-5",
                novalidate: "",
                onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
              }, [
                (_ctx.email)
                  ? (_openBlock(), _createBlock("input", {
                      key: 0,
                      type: "email",
                      name: "username",
                      autocomplete: "username",
                      value: _ctx.email,
                      readonly: "",
                      hidden: ""
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                _createVNode("div", null, [
                  _hoisted_17,
                  _createVNode("div", _hoisted_18, [
                    _withDirectives(_createVNode("input", {
                      id: "tutor-new-password",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.password = $event)),
                      type: _ctx.showPassword ? 'text' : 'password',
                      name: "new-password",
                      autocomplete: "new-password",
                      autocapitalize: "none",
                      spellcheck: "false",
                      disabled: _ctx.busy,
                      "aria-invalid": _ctx.submitted && !_ctx.validPassword,
                      "aria-describedby": "tutor-password-rules",
                      class: ["h-11 w-full rounded-md border bg-primary-100 pl-3 pr-12 text-base text-gray-700 outline-none transition-colors duration-200 focus:border-primary-500", 
                    _ctx.submitted && !_ctx.validPassword
                      ? 'border-red-500'
                      : 'border-transparent'
                  ]
                    }, null, 10, ["type", "disabled", "aria-invalid"]), [
                      [_vModelDynamic, _ctx.password]
                    ]),
                    _createVNode("button", {
                      type: "button",
                      class: "absolute inset-y-0 right-1 my-auto flex h-9 w-9 items-center justify-center rounded-md text-gray-500 hover:bg-white focus:outline-none focus:ring-2 focus:ring-primary-500",
                      "aria-label": 
                    _ctx.showPassword ? 'パスワードを隠す' : 'パスワードを表示'
                  ,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
                    }, [
                      (_ctx.showPassword)
                        ? (_openBlock(), _createBlock("svg", _hoisted_19, [
                            _hoisted_20
                          ]))
                        : (_openBlock(), _createBlock("svg", _hoisted_21, [
                            _hoisted_22,
                            _hoisted_23
                          ]))
                    ], 8, ["aria-label"])
                  ]),
                  _createVNode("ul", _hoisted_24, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rules, (rule) => {
                      return (_openBlock(), _createBlock("li", {
                        key: rule.id,
                        class: ["relative flex items-start gap-1.5 text-xs", _ctx.ruleTextClass(rule.state)]
                      }, [
                        _createVNode("span", {
                          class: ["mt-px flex h-4 w-4 flex-none items-center justify-center rounded-full", _ctx.ruleIconClass(rule.state)],
                          "aria-hidden": "true"
                        }, [
                          (rule.state === 'met')
                            ? (_openBlock(), _createBlock("svg", _hoisted_25, [
                                _hoisted_26
                              ]))
                            : (rule.state === 'broken')
                              ? (_openBlock(), _createBlock("svg", _hoisted_27, [
                                  _hoisted_28
                                ]))
                              : _createCommentVNode("", true)
                        ], 2),
                        _createVNode("span", null, [
                          _createTextVNode(_toDisplayString(rule.label), 1),
                          (rule.state !== 'pending')
                            ? (_openBlock(), _createBlock("span", _hoisted_29, _toDisplayString(rule.state === "met"
                        ? "（満たしています）"
                        : "（満たしていません）"), 1))
                            : _createCommentVNode("", true)
                        ])
                      ], 2))
                    }), 128))
                  ])
                ]),
                _createVNode("div", null, [
                  _hoisted_30,
                  _createVNode("div", _hoisted_31, [
                    _withDirectives(_createVNode("input", {
                      id: "tutor-confirm-password",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmation = $event)),
                      type: _ctx.showConfirmation ? 'text' : 'password',
                      name: "confirm-password",
                      autocomplete: "new-password",
                      autocapitalize: "none",
                      spellcheck: "false",
                      disabled: _ctx.busy,
                      "aria-invalid": _ctx.confirmError,
                      "aria-describedby": 
                    _ctx.confirmMessage ? 'tutor-confirm-message' : undefined
                  ,
                      class: ["h-11 w-full rounded-md border bg-primary-100 pl-3 pr-12 text-base text-gray-700 outline-none transition-colors duration-200 focus:border-primary-500", 
                    _ctx.confirmError ? 'border-red-500' : 'border-transparent'
                  ],
                      onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.confirmBlurred = true))
                    }, null, 42, ["type", "disabled", "aria-invalid", "aria-describedby"]), [
                      [_vModelDynamic, _ctx.confirmation]
                    ]),
                    _createVNode("button", {
                      type: "button",
                      class: "absolute inset-y-0 right-1 my-auto flex h-9 w-9 items-center justify-center rounded-md text-gray-500 hover:bg-white focus:outline-none focus:ring-2 focus:ring-primary-500",
                      "aria-label": 
                    _ctx.showConfirmation ? 'パスワードを隠す' : 'パスワードを表示'
                  ,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showConfirmation = !_ctx.showConfirmation))
                    }, [
                      (_ctx.showConfirmation)
                        ? (_openBlock(), _createBlock("svg", _hoisted_32, [
                            _hoisted_33
                          ]))
                        : (_openBlock(), _createBlock("svg", _hoisted_34, [
                            _hoisted_35,
                            _hoisted_36
                          ]))
                    ], 8, ["aria-label"])
                  ]),
                  (_ctx.confirmMessage)
                    ? (_openBlock(), _createBlock("p", {
                        key: 0,
                        id: "tutor-confirm-message",
                        class: ["mt-2 text-xs", _ctx.matches ? 'text-green-700' : 'text-red-600']
                      }, _toDisplayString(_ctx.matches ? "✓ " : "") + _toDisplayString(_ctx.confirmMessage), 3))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.error)
                  ? (_openBlock(), _createBlock("div", _hoisted_37, _toDisplayString(_ctx.error), 1))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_38, [
                  (!_ctx.required)
                    ? (_openBlock(), _createBlock(_component_MButton, {
                        key: 0,
                        color: "sub-600",
                        "hover-color": "sub-500",
                        outline: "",
                        disabled: _ctx.busy,
                        onClick: _ctx.cancel
                      }, {
                        default: _withCtx(() => [
                          _hoisted_39
                        ]),
                        _: 1
                      }, 8, ["disabled", "onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode("button", {
                    type: "submit",
                    class: ["rounded-md bg-primary-500 px-5 py-2 text-sm font-bold text-white transition-colors duration-200 hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary-600 focus:ring-offset-2 disabled:cursor-default disabled:bg-gray-300", _ctx.required ? 'w-full py-3' : ''],
                    disabled: _ctx.busy
                  }, _toDisplayString(_ctx.busy ? "変更しています…" : "パスワードを変更する"), 11, ["disabled"])
                ])
              ], 32)),
          (!_ctx.required && !_ctx.done)
            ? (_openBlock(), _createBlock("p", _hoisted_40, " ほかの端末やブラウザでログインしている場合は、変更後に新しいパスワードでログインし直してください。 "))
            : _createCommentVNode("", true)
        ]),
        (_ctx.required)
          ? (_openBlock(), _createBlock("section", _hoisted_41, [
              _hoisted_42,
              (_ctx.supportError)
                ? (_openBlock(), _createBlock("div", _hoisted_43, [
                    _hoisted_44,
                    _createVNode("button", {
                      type: "button",
                      class: "rounded-md px-2 py-1 text-sm font-medium text-gray-800 underline hover:bg-primary-100",
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.loadSupport && _ctx.loadSupport(...args)))
                    }, " 再読み込み ")
                  ]))
                : (!_ctx.support)
                  ? (_openBlock(), _createBlock("p", _hoisted_45, " 読み込み中… "))
                  : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                      (_ctx.support.useChannelTalk || _ctx.support.contactUrl)
                        ? (_openBlock(), _createBlock("div", _hoisted_46, [
                            (_ctx.support.useChannelTalk)
                              ? (_openBlock(), _createBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "w-full rounded-md border border-primary-500 px-4 py-2 text-sm font-bold text-gray-800 transition-colors duration-200 hover:bg-primary-100 focus:outline-none focus:ring-2 focus:ring-primary-500",
                                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.contact && _ctx.contact(...args)))
                                }, " チャットで問い合わせる "))
                              : _createCommentVNode("", true),
                            (_ctx.support.contactUrl)
                              ? (_openBlock(), _createBlock("a", {
                                  key: 1,
                                  href: _ctx.support.contactUrl,
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  class: "block w-full rounded-md border border-primary-500 px-4 py-2 text-center text-sm font-bold text-gray-800 transition-colors duration-200 hover:bg-primary-100 focus:outline-none focus:ring-2 focus:ring-primary-500"
                                }, "お問い合わせページを開く ↗", 8, ["href"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_47,
                      (!_ctx.topics.length)
                        ? (_openBlock(), _createBlock("p", _hoisted_48, " お知らせはありません。 "))
                        : (_openBlock(), _createBlock("ul", _hoisted_49, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.visibleTopics, (topic) => {
                              return (_openBlock(), _createBlock("li", {
                                key: topic.id
                              }, [
                                _createVNode("a", {
                                  href: topic.url,
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  class: "relative block rounded-md py-2 hover:bg-primary-100 focus:outline-none focus:ring-2 focus:ring-primary-500"
                                }, [
                                  _createVNode("span", _hoisted_50, _toDisplayString(_ctx.topicDate(topic.timestamp)), 1),
                                  _createVNode("span", _hoisted_51, _toDisplayString(topic.label), 1),
                                  _hoisted_52
                                ], 8, ["href"])
                              ]))
                            }), 128))
                          ])),
                      (_ctx.topics.length > _ctx.visibleTopicCount)
                        ? (_openBlock(), _createBlock("button", {
                            key: 3,
                            type: "button",
                            class: "mt-2 rounded-md px-2 py-1 text-sm text-gray-600 underline hover:bg-primary-100",
                            "aria-expanded": _ctx.showAllTopics,
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showAllTopics = !_ctx.showAllTopics))
                          }, _toDisplayString(_ctx.showAllTopics ? "閉じる" : `すべて表示（${_ctx.topics.length}件）`), 9, ["aria-expanded"]))
                        : _createCommentVNode("", true)
                    ], 64))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}